module.exports = __webpack_public_path__ + "img/solutions1@2x.710ae22.png";